import { z } from "zod/v4";
import { MAP_NOTE_PIN_MARKERS } from "../types/mapNotePin.js";
import { noteAudienceSchema } from "./mapNoteEntries.js";
// `color` is the legacy field name; the union now spans both the original
// colored pins and the newer banner markers (see MapNotePinColor).
const mapNoteColorSchema = z.enum(MAP_NOTE_PIN_MARKERS);
export const createMapNoteTemplateInputSchema = z.object({
    name: z.string().optional(),
    color: mapNoteColorSchema.optional(),
    visibleToPlayers: z.boolean().optional(),
    hidden: z.boolean().optional(),
});
export const updateMapNoteTemplateInputSchema = z.object({
    name: z.string().optional(),
    color: mapNoteColorSchema.optional(),
    visibleToPlayers: z.boolean().optional(),
    hidden: z.boolean().optional(),
});
export const createMapNoteTemplateEntryInputSchema = z.object({
    audience: noteAudienceSchema,
    parentEntryId: z.string().nullable().optional(),
    title: z.string().optional().default(""),
    content: z.unknown().optional().default([]),
    position: z.number().int().optional(),
});
export const updateMapNoteTemplateEntryInputSchema = z.object({
    title: z.string().optional(),
    content: z.unknown().optional(),
    position: z.number().int().optional(),
});
export const createTemplateFromMapNoteInputSchema = z.object({
    mapNoteId: z.string().min(1),
    campaignId: z.string().min(1),
    name: z.string().optional(),
});
